import { TAccount, TAccountType, TColor, TCurrency, TIcon } from "@/api/v1_0";
import { JSONSchema, validateData } from "@/validation";
import {
  Enum,
  MinLength,
  NotNullable,
  Optional,
  Required,
  Rules,
  Same,
  Uuid,
} from "@/validation/rules";
import { Color } from "./color";
import { Currency } from "./currency";
import { Icon } from "./icons";

export namespace IncomeSource {
  export interface IInput {
    uuid?: string;
    type: TAccountType;
    name?: string;
    currency?: TCurrency;
    icon?: TIcon;
    color?: TColor;
  }

  export interface IErrors {
    uuid?: string;
    type?: string;
    name?: string;
    currency?: string;
    icon?: string;
    color?: string;
  }

  export const create = (currency: TCurrency): IInput => ({
    currency,
    type: TAccountType.IncomeSource,
  });

  const validationRules: JSONSchema<IInput> = {
    type: "object",
    properties: {
      uuid: Rules(Optional(), Uuid()),
      type: Rules(Required(), Same(TAccountType.IncomeSource)),
      name: Rules(Required(), NotNullable(), MinLength(1)),
      currency: Rules(Required(), Enum(Currency.currencies)),
      icon: Rules(Optional(), Enum(Icon.icons)),
      color: Rules(Optional(), Enum(Color.colors)),
    },
  };

  export const validate = (input: IInput) =>
    validateData<IInput, IErrors, TAccount>(input, validationRules);
}
